export enum FB_PIXEL_EVENTS {
  PURCHASE = "Purchase",
  NEW_COMMUNITY = "NewCommunity",
  LOG_IN = "Login",
}
